import { number } from 'prop-types';
import React from 'react';

import InfoTooltip from '../../generic/Tooltip/InfoTooltip';
import OpenAmount from '../../layout/OpenAmount';
import HELP_TEXTS from '../help-texts';

function BudgetData({
  openBudget,
  securedBudget,
  securedPushedBudget,
  openChangeRequests,
}) {
  return (
    <div className="d-flex">
      <span className="p-1">
        <OpenAmount description="Open Budget" value={openBudget} />
        <InfoTooltip target="open-budget" className="text-muted">
          {HELP_TEXTS.info.openBudget}
        </InfoTooltip>
      </span>
      <span className="p-1">
        <OpenAmount
          className="ml-4"
          description="Secured Budget"
          value={securedBudget}
        />
        <InfoTooltip target="secured-budget" className="text-muted">
          {HELP_TEXTS.info.securedBudget}
        </InfoTooltip>
      </span>
      <span className="p-1">
        <OpenAmount
          className="ml-4"
          description="Secured Pushed Budget"
          value={securedPushedBudget}
        />
        <InfoTooltip target="secured-pushed-budget" className="text-muted">
          {HELP_TEXTS.info.securedPushedBudget}
        </InfoTooltip>
      </span>
      <span className="p-1 text-muted ml-4">
        Open Change Requests: {openChangeRequests}
        <InfoTooltip target="open-change-requests" className="text-muted">
          {HELP_TEXTS.info.openChangeRequests}
        </InfoTooltip>
      </span>
    </div>
  );
}

BudgetData.propTypes = {
  openBudget: number.isRequired,
  securedBudget: number.isRequired,
  securedPushedBudget: number.isRequired,
  openChangeRequests: number.isRequired,
};

export default BudgetData;
